<template>
	<div class="task-item">
		<van-swipe-cell>
			<div class="task-item-wrap">
				<div class="check-wrap" v-if="isShowEdit">
					<van-checkbox v-model="props.item.checked" shape="square" />
				</div>
				<div class="content-wrap" @click="toTaskDetail">
					<img v-if="taskState === 0" class="ico" src="@/assets/img/task/todotask.png" alt="" />
					<img
						v-else-if="taskState === 1"
						class="ico"
						src="@/assets/img/task/finishtask.png"
						alt=""
					/>
					<img v-else-if="taskState === 2" class="ico" src="@/assets/img/task/mytask.png" alt="" />
					<div class="title-wrap">
						<HighLight
							:keyword="props.keywords"
							:text="props.item.subject || props.item.process_name || props.item.process_NAME"
						/>
						<div class="sub-title">
							<span>
								<template v-if="taskState === 0">
									{{ props.item.created_on }}
								</template>
								<template v-if="taskState === 1">
									{{ props.item.created_ON }}
								</template>
								<template v-if="taskState === 2">
									{{ props.item.process_INSTANCE_START_DATE }}
								</template>
							</span>
						</div>
					</div>
					<template v-if="taskState === 0">
						<div class="tag yb">待审批</div>
					</template>
					<template v-else-if="taskState === 1">
						<template
							v-if="
								props.item.process_instance_status === 'COMPLETE' ||
								props.item.process_INSTANCE_STATUS === 'COMPLETE'
							"
						>
							<div class="tag yzz">已办结</div>
						</template>
						<template v-else>
							<div class="tag yb">进行中</div>
						</template>
					</template>
					<template v-else-if="taskState === 2">
						<template
							v-if="
								props.item.process_instance_status === 'RUNNING' ||
								props.item.process_INSTANCE_STATUS === 'RUNNING'
							"
						>
							<div class="tag yb">办理中</div>
						</template>
						<template v-else>
							<div class="tag yzz">已办结</div>
						</template>
					</template>
					<van-icon class="to-detail-ico" name="arrow" />
					<!--<div class="task-item-row" @click="toTaskDetail">-->
					<!--	<div class="title-area">-->
					<!--		<div class="task-title">-->
					<!--			<HighLight-->
					<!--				:keyword="props.keywords"-->
					<!--				:text="props.item.subject || props.item.process_name || props.item.process_NAME"-->
					<!--			/>-->
					<!--			&lt;!&ndash;{{ props.item.subject || props.item.process_name || props.item.process_NAME }}&ndash;&gt;-->
					<!--			&lt;!&ndash;<template v-if="taskState === 0">&ndash;&gt;-->
					<!--			&lt;!&ndash;	{{ props.item.process_name }}&ndash;&gt;-->
					<!--			&lt;!&ndash;</template>&ndash;&gt;-->
					<!--			&lt;!&ndash;<template v-if="taskState === 1">&ndash;&gt;-->
					<!--			&lt;!&ndash;	{{ props.item.subject }}&ndash;&gt;-->
					<!--			&lt;!&ndash;</template>&ndash;&gt;-->
					<!--			&lt;!&ndash;<template v-if="taskState === 2">&ndash;&gt;-->
					<!--			&lt;!&ndash;	{{ props.item.process_NAME }}&ndash;&gt;-->
					<!--			&lt;!&ndash;</template>&ndash;&gt;-->
					<!--		</div>-->
					<!--		<template v-if="taskState === 0">-->
					<!--			<div class="tag yb">待审批</div>-->
					<!--		</template>-->
					<!--		<template v-else-if="taskState === 1">-->
					<!--			<template-->
					<!--				v-if="-->
					<!--					props.item.process_instance_status === 'COMPLETE' ||-->
					<!--					props.item.process_INSTANCE_STATUS === 'COMPLETE'-->
					<!--				"-->
					<!--			>-->
					<!--				<div class="tag yzz">已办结</div>-->
					<!--			</template>-->
					<!--			<template v-else>-->
					<!--				<div class="tag yb">进行中</div>-->
					<!--			</template>-->
					<!--		</template>-->
					<!--		<template v-else-if="taskState === 2">-->
					<!--			<template-->
					<!--				v-if="-->
					<!--					props.item.process_instance_status === 'RUNNING' ||-->
					<!--					props.item.process_INSTANCE_STATUS === 'RUNNING'-->
					<!--				"-->
					<!--			>-->
					<!--				<div class="tag yb">办理中</div>-->
					<!--			</template>-->
					<!--			<template v-else>-->
					<!--				<div class="tag yzz">已办结</div>-->
					<!--			</template>-->
					<!--		</template>-->
					<!--		<template v-else>-->
					<!--			<template-->
					<!--				v-if="-->
					<!--					props.item.process_instance_status === 'RUNNING' ||-->
					<!--					props.item.process_INSTANCE_STATUS === 'RUNNING'-->
					<!--				"-->
					<!--			>-->
					<!--				&lt;!&ndash;<div class="tag yb">特急</div>&ndash;&gt;-->
					<!--				<div class="tag yb">待审批</div>-->
					<!--			</template>-->
					<!--			<template-->
					<!--				v-if="-->
					<!--					props.item.process_instance_status === 'COMPLETE' ||-->
					<!--					props.item.process_INSTANCE_STATUS === 'COMPLETE'-->
					<!--				"-->
					<!--			>-->
					<!--				&lt;!&ndash;<div class="tag jjz">进行中</div>&ndash;&gt;-->
					<!--				<div class="tag yzz">已结束</div>-->
					<!--			</template>-->
					<!--			<template-->
					<!--				v-if="-->
					<!--					props.item.process_instance_status === 'ABORT' ||-->
					<!--					props.item.process_INSTANCE_STATUS === 'ABORT'-->
					<!--				"-->
					<!--			>-->
					<!--				&lt;!&ndash;<div class="tag ycx">已撤销</div>&ndash;&gt;-->
					<!--				<div class="tag ycx">已终止</div>-->
					<!--			</template>-->
					<!--		</template>-->
					<!--	</div>-->
					<!--	<div class="source-area">-->
					<!--		<div class="source">-->
					<!--			&lt;!&ndash;来源：&ndash;&gt;-->
					<!--			&lt;!&ndash;<template v-if="taskState === 0">&ndash;&gt;-->
					<!--			&lt;!&ndash;	{{ props.item.process_source }}&ndash;&gt;-->
					<!--			&lt;!&ndash;</template>&ndash;&gt;-->
					<!--			&lt;!&ndash;<template v-if="taskState === 1 || taskState === 2">&ndash;&gt;-->
					<!--			&lt;!&ndash;	{{ props.item.process_SOURCE }}&ndash;&gt;-->
					<!--			&lt;!&ndash;</template>&ndash;&gt;-->
					<!--			<template v-if="props.item.assign_name">-->
					<!--				发起方：{{ props.item.assign_name }}-->
					<!--			</template>-->
					<!--		</div>-->
					<!--		<div class="time">-->
					<!--			<template v-if="taskState === 0">-->
					<!--				{{ props.item.created_on }}-->
					<!--			</template>-->
					<!--			<template v-if="taskState === 1">-->
					<!--				{{ props.item.created_ON }}-->
					<!--			</template>-->
					<!--			<template v-if="taskState === 2">-->
					<!--				{{ props.item.process_INSTANCE_START_DATE }}-->
					<!--			</template>-->
					<!--		</div>-->
					<!--	</div>-->
					<!--	&lt;!&ndash;<div class="apply-area" v-if="taskState === 0">&ndash;&gt;-->
					<!--	&lt;!&ndash;	<div class="username">发起方：{{ props.item.assign_name }}</div>&ndash;&gt;-->
					<!--	&lt;!&ndash;</div>&ndash;&gt;-->
					<!--	&lt;!&ndash;<div v-if="taskState === 1" class="source-area">&ndash;&gt;-->
					<!--	&lt;!&ndash;	<div />&ndash;&gt;-->
					<!--	&lt;!&ndash;	<div class="tag cklct">查看流程图</div>&ndash;&gt;-->
					<!--	&lt;!&ndash;</div>&ndash;&gt;-->
					<!--</div>-->
				</div>
			</div>
			<!--<template #right>-->
			<!--	<div v-if="taskState === 3" class="cancel-wrap">-->
			<!--		<img src="@/assets/img/commonLayout/back.png" alt="" />-->
			<!--		<span>撤销</span>-->
			<!--	</div>-->
			<!--	<div v-else class="remove-wrap">-->
			<!--		<van-icon name="delete-o" />-->
			<!--		<span>删除</span>-->
			<!--	</div>-->
			<!--</template>-->
		</van-swipe-cell>
	</div>
</template>
<script setup lang="ts">
import { inject } from 'vue'
import HighLight from '@/components/HighLight/index.vue'
import { openWebview } from '@/utils'
import getNativeInstance from '@/utils/JSBridge'

const props = defineProps<{
	keywords?: string
	item: object
	isShowEdit: boolean
}>()

const taskState = inject<any>('taskState')
const router = useRouter()

const toTaskDetail = () => {
	console.log(props.item)
	console.log(taskState.value)
	if (taskState.value === 0) {
		if (window.isIOS) {
			if (window.UniAppJSBridge) {
				getNativeInstance().customInvoke({
					action: 'setAppStatusBar',
					data: {
						visible: true
					}
				})
			}
			window.location.href = props.item.form_mobile_url
		} else {
			router.push({
				path: '/layout/application-page',
				query: {
					link: props.item.form_mobile_url,
					title: props.item.process_name
				}
			})
			// openWebview({
			// 	url: props.item.form_url || props.item.form_mobile_url,
			// 	title: props.item.process_name
			// })
		}
	}
	if (taskState.value === 1) {
		// openWebview({
		// 	url: props.item.form_MOBILE_URL || props.item.form_URL,
		// 	title: props.item.subject
		// })
		if (window.isIOS) {
			if (window.UniAppJSBridge) {
				getNativeInstance().customInvoke({
					action: 'setAppStatusBar',
					data: {
						visible: true
					}
				})
			}
			window.location.href = props.item.form_MOBILE_URL || props.item.form_URL
		} else {
			router.push({
				path: '/layout/application-page',
				query: {
					link: props.item.form_MOBILE_URL || props.item.form_URL,
					title: props.item.subject
				}
			})
			// openWebview({
			// 	url: props.item.form_MOBILE_URL || props.item.form_URL,
			// 	title: props.item.subject
			// })
		}
	}
	if (taskState.value === 2) {
		router.push({
			path: '/page/taskRecord',
			query: { processInstanceId: props.item.process_INSTANCE_ID, appId: props.item.app_ID }
		})
	}
}
</script>

<style scoped lang="scss">
.task-item {
	.check-wrap {
		padding-left: 15px;
	}
	.remove-wrap,
	.cancel-wrap {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 20px 26px;
		box-sizing: border-box;
		font-weight: 400;
		font-size: 24px;
		color: #ffffff;
		line-height: 19px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		> span {
			margin-top: 8px;
			font-size: 16px;
		}
		background: $dangerColor;
	}
	.cancel-wrap {
		> img {
			width: 24px;
		}
		background: #dfdfdf;
		color: #7d7e80;
	}
	.task-item-wrap {
		display: flex;
		align-items: center;
		.content-wrap {
			display: flex;
			align-items: center;
			margin: 0 15px;
			box-sizing: border-box;
			border-bottom: 1px solid #f4f3f3;
			flex: 1;
			.ico {
				width: 20px;
				flex-shrink: 0;
				margin-right: 15px;
			}
			.title-wrap {
				padding: 12px 0;
				box-sizing: border-box;
				flex: 1 0;
				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: $commonFontSize;
				color: #424649;
				.sub-title {
					display: flex;
					font-weight: 400;
					font-size: $smallFontSize;
					color: #7d7e80;
					margin-top: 10px;
				}
			}
			.tag {
				flex-shrink: 0;
				padding: 2px 8px;
				height: 24px;
				border-radius: 2px;
				font-weight: 400;
				font-size: $smallFontSize;
				text-align: center;
				font-style: normal;
				text-transform: none;
				display: flex;
				align-items: center;
			}
			.tj {
				//background: rgba(255, 35, 12, 0.1);
				//border: 1px solid #ff230c;
				color: #ff230c;
			}
			.jj {
				//background: rgba(255, 144, 1, 0.1);
				//border: 1px solid #ff9001;
				color: #ff9001;
			}
			.yb {
				//background: rgba(37, 189, 239, 0.1);
				//border: 1px solid #25bdef;
				color: #25bdef;
			}
			.jjz,
			.dsh {
				//background: rgba(255, 197, 60, 0.1);
				//border: 1px solid #ffc53c;
				color: #ffc53c;
			}
			.ywc {
				//background: rgba(88, 191, 40, 0.1);
				//border: 1px solid #58bf28;
				color: #58bf28;
			}
			.yzz {
				//background: rgba(243, 63, 18, 0.1);
				//border: 1px solid #f33f12;
				color: #f33f12;
			}
			.cklct,
			.ycx {
				//border: 1px solid #c8c9cd;
				color: #c8c9cd;
			}
			.to-detail-ico {
				font-weight: 400;
				font-size: $smallFontSize;
				color: #7d7e80;
			}
		}
	}
}
</style>
